import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import DayPicker, {DateUtils} from 'react-day-picker';
import moment from 'moment';
import localeUtils from '../../../../../../../../../../../../i18n/reactDayPickerLocaleData.js';
import 'react-day-picker/lib/style.css';
import './styles/reactDayPickerStyles.css';

function isSelectingFirstDay(from, to, day) {
  const firstDayIsNotSelected = !from;
  const selectedDayIsBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
  const rangeIsSelected = from && to;
  return firstDayIsNotSelected || selectedDayIsBeforeFirstDay || rangeIsSelected;
}

function getStateFromProps(props) {
  const to = moment(props.to).subtract(1, 'days').toDate();
  return {
    from: moment(props.from).toDate(),
    to: to,
    enteredTo: to,
  };
}

@injectIntl
class DayPickerContainer extends Component {
  constructor(props) {
    super(props);
    this.state = getStateFromProps(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.from !== nextProps.from || this.props.to !== nextProps.to) {
      this.setState(getStateFromProps(nextProps));
    }
  }

  handleDayClick = (day, {disabled}, event) => {
    if (disabled) {
      event.target.blur();
      return;
    }

    const {from, to} = this.state;

    if (isSelectingFirstDay(from, to, day)) {
      this.setState({
        from: day,
        to: null,
        enteredTo: null,
      });
    } else {
      this.setState({
        to: day,
        enteredTo: day,
      });
      this.props.onChange({
        from: moment(from).format('YYYY-MM-DD'),
        to: moment(day).add(1, 'days').format('YYYY-MM-DD'),
      });
    }
  };

  handleDayMouseEnter = day => {
    const {from, to} = this.state;

    if (!isSelectingFirstDay(from, to, day)) {
      this.setState({
        enteredTo: day,
      });
    }
  };

  handleWeekClick = (week, days, event) => {
    event.target.blur();
    const from = days[0];
    const to = days[6];
    this.setState({
      from,
      to,
      enteredTo: to,
    })
    this.props.onChange({
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).add(1, 'days').format('YYYY-MM-DD'),
    });
  };

  render() {
    const {from, to, enteredTo} = this.state;
    const firstDate = moment.utc(this.props.firstDate).toDate();
    return (
      <DayPicker
        numberOfMonths={2}
        showWeekNumbers={true}
        selectedDays={[from, {from, to: enteredTo}]}
        disabledDays={day => DateUtils.isFutureDay(day) || DateUtils.isDayBefore(day, firstDate)}
        initialMonth={moment(to).subtract(1, 'months').toDate()}
        fromMonth={firstDate}
        toMonth={new Date()}
        onDayClick={this.handleDayClick}
        onDayMouseEnter={this.handleDayMouseEnter}
        onWeekClick={this.handleWeekClick}
        localeUtils={localeUtils}
        locale={this.props.intl.locale}
      />
    );
  }

}

export default DayPickerContainer;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/DateRangePicker/components/DayPickerContainer/DayPickerContainer.js